import { UnitsEditPayload, UpdateUnitsItem } from '../../../../types/object-editor.types';

export const isUnitsEditPayload = (x: UpdateUnitsItem): x is UnitsEditPayload => {
  return !Array.isArray(x);
}